import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';




import { ProcessosCorrelatosService } from '../../../providers/processos-correlatos-service';

import { UsuarioService } from '../../../providers/usuario-service';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { JurisdicionadoService } from '../../../providers/jurisdicionado-service';
import { AlertService } from '../../../providers/alert-service';

import { MenuService } from '../../../providers/menu-service';

import { ModulosController } from '../modulos-controller';

import { ModalPreVisualizarProcessosCorrelatosPage } from '../../modais/modal-pre-visualizacao/processos-correlatos/modal-pv-processos-correlatos';

@Component({
  selector: 'page-processos-correlatos',
  templateUrl: 'processos-correlatos.html',
  providers: [
    ProcessosCorrelatosService
  ]
})
export class ProcessosCorrelatosPage extends ModulosController {

  // Lista Construtora da Página
  listaEntidades: any;
  listaTipoReponsaveis: any;
  pesquisaAtiva: boolean = true;
  isJurisdicionado: any;
  incluindoNoCertificado: boolean = false;
  idEntidadeConstante: number = 1;
  loading: boolean = true;

  processosCorrelatos: any = {
    anoExercicio: "",
    entidade: { numero: "", nome: "" },
    idPca: "",
    idEntidade: "",
    idProcessosCorrelatos: "",
    parecer: "",
    listaProcessosCorrelatos: []
  };

  usuario: any;

  //Construtor da Página
  constructor(private processosCorrelatosService: ProcessosCorrelatosService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    public alertService: AlertService,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public jurisdicionadoService: JurisdicionadoService,
    public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    usuarioService.usuarioSetado.subscribe(dadosUsuario => {
      this.usuario = dadosUsuario.usr;
    });

    this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    this.processosCorrelatos = {
      anoExercicio: this.gestaoPcaService.getPCA().dsAnoexercicio,
      entidade: { numero: this.idEntidadeConstante, nome: this.usuario.dadosUsuario[0].entidade },
      idEntidade: this.idEntidadeConstante,
      idProcessosCorrelatos: "",
      idPca: this.gestaoPcaService.getPCA().id,
      parecer: ""
    };

    // this.buscarNomeEntidade();
    this.carregarModulo();
    this.setModuloId(3);
  }

  buscarNomeEntidade() {
    this.processosCorrelatosService.buscarNomeEntidade(this.idEntidadeConstante).subscribe(data => this.processosCorrelatos.entidade.nome = data.nmEntidade, error => console.log("erro: " + error));
  }

  carregarModulo() {
    this.listarProcessosCorrelatos();
  }

  listarProcessosCorrelatos() {
    this.processosCorrelatosService.listarProcessos(this.processosCorrelatos.anoExercicio,
      this.processosCorrelatos.entidade.numero,
      this.processosCorrelatos.idPca).subscribe(
        data => {
          if (data != null && data != undefined) {
            this.processosCorrelatos.idProcessosCorrelatos = data.idProcessosCorrelatos;
            this.processosCorrelatos.listaProcessosCorrelatos = data.listaProcessosCorrelatos;
            this.processosCorrelatos.parecer = data.parecer;
          }

          this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 3).subscribe(data => {
            this.setIdModuloPca(data.moduloPca);
            this.loading = false;
          }, error => {
            console.log("erro ao carregar modulo pca: " + error);
          });
        }, error => {
          this.processosCorrelatos.listaProcessosCorrelatos = []
          this.loading = false;
        });
  }

  importarProcessos(exibirMensagem: boolean = true) {
    this.incluindoNoCertificado = true;

    let jsonTodoProcessos: any = {
      idProcessosCorrelatos: this.processosCorrelatos.idProcessosCorrelatos,
      idEntidade: this.processosCorrelatos.idEntidade,
      idPca: this.processosCorrelatos.idPca,
      parecer: this.processosCorrelatos.parecer,
      listaProcessosCorrelatos: this.processosCorrelatos.listaProcessosCorrelatos
    };

    this.processosCorrelatosService.importarProcessosCorrelatos(jsonTodoProcessos).subscribe(data => {
      this.incluindoNoCertificado = false;
      if (exibirMensagem) {
        this.alertService.mostraAlerta("Processos Correlatos", "Realizado com sucesso!");
      }
      this.carregarModulo();
    }, error => {
      console.log("erro: " + error);
      this.incluindoNoCertificado = false;
    });
  }

  apresentaModalPreVisualizacao(titulo: String, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, { param1: titulo, jurisdicionado: this.isJurisdicionado });
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }

  previsualizarCertificado() {
    this.importarProcessos(false);
    this.apresentaModalPreVisualizacao("Pré-visualização do Certificado", ModalPreVisualizarProcessosCorrelatosPage);
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/processos-correlatos/processos-correlatos.ts